import * as types from "../../mutation-types";

export default {
    [types.FETCH_USER_CALENDAR] (state, { data }) {
        state.days = data;
    },

    [types.FETCH_USER_CALENDAR_FAILURE] (state) {
        state.days = null;
    },

    [types.FETCH_USER_WEEK] (state, { data }) {
        state.date = data;
    },
    [types.FETCH_USER_CALENDAR_ELEMENT] (state, { data }) {
        state.element = data;
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/hairRegimen/mutations.js